
    import { Component, namespace } from 'nuxt-property-decorator';
    import { PageComponent, PageOptions } from '@/store/page';
    import ScrollToTopBtn from '@/components/blocks/ScrollToTopBtn.vue';
    import components from '@/components';
    import PageMixin from '@/mixins/PageMixin.vue';
    import { mixins } from 'nuxt-property-decorator';
    import PaletteStylesMixin from '@/mixins/paletteStylesMixin';
    import { UtmUtils } from '@/utils/utm';
    import PageWrapper from '@/components/editor/page/PageWrapper.vue';
    const page = namespace('page');
    @Component({
        components: {
            PageWrapper,
            ...components,
            ScrollToTopBtn
        }
    })
    export default class Index extends mixins(PageMixin, PaletteStylesMixin) {
        @page.State options: PageOptions;
        @page.State components: PageComponent[];

        async fetch({ store, params, error }) {
            await store.dispatch('loadPageStore', 'page');
            await store.dispatch('pages/fetchAllGroups');
            await store.dispatch('entities/fetchAll', 'forms');
            await store.dispatch('entities/fetchAll', 'colors');
            const result = await store.dispatch('page/fetch', {
                slug: params.slug
            });

            if (result === 'error') {
                error({ statusCode: 404, message: 'Post not found' });
            }
        }

        beforeMount() {
            const utmService = new UtmUtils();
            utmService.fetchUtmFromQuery(this.$route.query);
            utmService.save();
        }
    }
